var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInproduction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20311 -1865)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-20311 1865)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15356.865 -3241.458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4940.969,5121.509c-1.04.265-1.649-.231-2.222-1.066-1.006-1.468-2.127-2.857-3.212-4.271-.193-.252-.218-.422.032-.658q1.155-1.091,2.27-2.224c.215-.218.375-.249.624-.058,1.708,1.306,3.427,2.6,5.128,3.909a.854.854,0,0,1,.278.568c.034.689-.008,1.383.025,2.073a1.05,1.05,0,0,0,.266.638c1.4,1.421,2.828,2.82,4.239,4.232a.737.737,0,0,0,.882.19,3.012,3.012,0,0,1,3.207.671c1.854,1.794,3.666,3.633,5.481,5.47a1.5,1.5,0,0,1-.037,2.25q-1.155,1.16-2.325,2.3a1.64,1.64,0,0,1-2.425,0c-1.767-1.754-3.534-3.507-5.277-5.283a3.171,3.171,0,0,1-.732-3.451.56.56,0,0,0-.157-.679c-1.378-1.359-2.756-2.721-4.1-4.109a1.387,1.387,0,0,0-1.249-.512A5.533,5.533,0,0,1-4940.969,5121.509Z",
    transform: "translate(-1.064 -0.162)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4830.374,5124.213a4.653,4.653,0,0,0,2.675-4.357c-.12.1-.25.183-.359.29-.654.648-1.294,1.312-1.967,1.942a.809.809,0,0,1-.59.171c-1.032-.14-2.057-.334-3.089-.476-.455-.063-.68-.215-.732-.727a29.64,29.64,0,0,0-.476-2.952.873.873,0,0,1,.3-.929c.61-.561,1.193-1.15,1.784-1.732.116-.113.219-.241.344-.379-1.133-.321-2.889.64-3.647,1.593-.86,1.08-1.122,1.938-1.087,3.938-.583-.675-1.468-1.01-1.3-2.1.1-.648.047-1.317.084-1.976a.958.958,0,0,1,.163-.464,6.588,6.588,0,0,1,5.2-3.123,11.752,11.752,0,0,1,2.233.145,1.38,1.38,0,0,1,1.206,1.068,1.474,1.474,0,0,1-.448,1.546c-.755.7-1.443,1.469-2.2,2.167a.936.936,0,0,0-.324,1.054c.092.3.107.749.307.858a3.436,3.436,0,0,0,1.286.277c.124.013.285-.158.4-.273.788-.777,1.575-1.554,2.346-2.346a1.411,1.411,0,0,1,1.466-.421,1.45,1.45,0,0,1,1.091,1.181,6.915,6.915,0,0,1-2.759,7.339.451.451,0,0,1-.725-.078C-4829.562,5125.033-4829.965,5124.64-4830.374,5124.213Z",
    transform: "translate(-99.11 0)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4940.605,5229.816c.5.5.961.969,1.449,1.459-.079.093-.159.2-.253.295q-2.814,2.854-5.628,5.706a1.49,1.49,0,0,0-.14,2.235,1.618,1.618,0,0,0,2.353-.088c1.58-1.59,3.149-3.192,4.724-4.789.134-.135.275-.263.366-.351.246.673.488,1.308.7,1.953a.457.457,0,0,1-.087.388c-1.5,1.516-2.98,3.061-4.542,4.514a3.527,3.527,0,0,1-5.109-.292,3.609,3.609,0,0,1,.141-5.032q2.845-2.858,5.7-5.7C-4940.833,5230.016-4940.729,5229.928-4940.605,5229.816Z",
    transform: "translate(0 -106.109)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInproduction);
export default __webpack_public_path__ + "static/media/icon-inproduction.06a59ad8.svg";
export { ForwardRef as ReactComponent };